export const GET_SNAPSHOTS = '/api/v1/user/profile/pnl/snapshots';
